// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectID = function (x) {
    return x;
};
var tsBridgeProjectID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectID")("__brandProjectID"));
    }
};
var writeProjectID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectID = Data_Show.showString;
var readProjectID = Simple_JSON.readString;
var ordProjectID = Data_Ord.ordString;
var newtypeProjectID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectID = ProjectID;
var eqProjectID = Data_Eq.eqString;
export {
    ProjectID,
    makeProjectID,
    unwrap,
    newtypeProjectID,
    eqProjectID,
    ordProjectID,
    showProjectID,
    readProjectID,
    writeProjectID,
    tsBridgeProjectID
};
//# sourceMappingURL=index.js.map
